/* eslint-env browser, node */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import feeCalculatorTotal from '../selectors/feeCalculatorTotal.selector';

class FeeCalculatorTotal extends Component {
  render() {
    const { total } = this.props;
    return (
      <div className="FeeCalculatorTotal">
        <h2 className="FeeCalculatorTotal-text">TOTAL <span className="FeeCalculatorTotal-number">{total || '0.00'}</span></h2>
        <span className="footnote print-only">* Fees and Totals contained herein are <em>estimations only</em> and are subject to change.</span>
        <button className="PrintBtn no-print" onClick={() => window.print()}>PRINT</button>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    total: feeCalculatorTotal(state),
  };
};

export default connect(mapStateToProps)(FeeCalculatorTotal);



// WEBPACK FOOTER //
// ./src/sections/FeeCalculatorTotal.js